import {useSettings} from '@wix/tpa-settings/react'
import {getEventTitle, getFormattedLocation, isTicketed} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import settingsParams from '../../../settingsParams'
import {useAppSelector} from '../../hooks/runtime'
import {isCouponInputVisible, isGiftCardInputVisible} from '../../selectors/checkout-options'
import {getDatesInformation} from '../../selectors/dates'
import {getEvent} from '../../selectors/event'
import {isMembershipSelectorVisible} from '../../selectors/paid-plans'
import {GiftCardInput} from '../gift-card-input'
import {CouponInput} from './coupon-input'
import {SummaryProps} from './interfaces'
import {MembershipDropdown} from './membership-dropdown'
import s from './summary.scss'
import {classes} from './summary.st.css'
import {TicketsSummary} from './tickets-summary'

export const Summary = ({currentStep}: SummaryProps) => {
  const settings = useSettings()

  const event = useAppSelector(getEvent)
  const date = useAppSelector(getDatesInformation).fullDate
  const couponInputVisible = useAppSelector(isCouponInputVisible)
  const membershipSelectorVisible = useAppSelector(isMembershipSelectorVisible)
  const giftCardInputVisible = useAppSelector(isGiftCardInputVisible)

  const title = getEventTitle(event)
  const location = getFormattedLocation(event)
  const ticketed = isTicketed(event)
  const formSummaryTitleTag = settings.get(settingsParams.formSummaryTitleTag) as string

  return (
    <div className={s.summary} id="event-summary">
      <div className={classNames(s.info, {[s.rsvp]: !ticketed})}>
        <Text tagName={formSummaryTitleTag} className={classes.title} data-hook="event-title">
          {title}
        </Text>
        <div className={classes.dateAndLocation}>
          <Text data-hook="event-time">{date}</Text>
          <Text data-hook="event-location">{location}</Text>
        </div>
      </div>
      {ticketed && (
        <>
          {couponInputVisible && <CouponInput currentStep={currentStep} />}
          {giftCardInputVisible && <GiftCardInput currentStep={currentStep} />}
          {membershipSelectorVisible && <MembershipDropdown currentStep={currentStep} />}
          <TicketsSummary />
        </>
      )}
    </div>
  )
}
